var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._includes(["doc", "docx", "xls", "xlsx", "zip"], _vm.type)
    ? _c("div", { staticClass: "row py-3 text-center" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("i", { staticClass: "far fa-file-alt" }),
          _vm._v(" "),
          _c("span", { staticClass: "text-uppercase ms-2" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.component.text || _vm.type) + "\n    "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 mt-4" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary",
              attrs: {
                href: `https://skyier-bucket.s3.eu-west-1.amazonaws.com/${_vm.component.file}`,
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm._f("translate")("Download")) + "\n    "
              ),
            ]
          ),
        ]),
      ])
    : _vm.type === "pdf"
    ? _c("div", [
        _vm.noDownload
          ? _c("div", [
              _c("div", { staticClass: "col-12" }, [
                _c("i", { staticClass: "far fa-file-alt" }),
                _vm._v(" "),
                _c("span", { staticClass: "text-uppercase ms-2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.component.text || _vm.type) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 mt-4" }, [
                _c("div", { staticClass: "ratio ratio-1x1" }, [
                  _c("iframe", {
                    attrs: {
                      src: `https://notapanda.github.io/skyier-pdf-viewer?url=https://skyier-bucket.s3.eu-west-1.amazonaws.com/${this.component.file}`,
                      frameborder: "0",
                    },
                  }),
                ]),
              ]),
            ])
          : !_vm.watermark
          ? _c("div", { staticClass: "text-center" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("i", { staticClass: "far fa-file-alt" }),
                _vm._v(" "),
                _c("span", { staticClass: "text-uppercase ms-2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.component.text || _vm.type) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 mt-4" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      href: `https://skyier-bucket.s3.eu-west-1.amazonaws.com/${_vm.component.file}`,
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("translate")("Download")) +
                        "\n      "
                    ),
                  ]
                ),
              ]),
            ])
          : _c("div", { staticClass: "text-center" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("i", { staticClass: "far fa-file-alt" }),
                _vm._v(" "),
                _c("span", { staticClass: "text-uppercase ms-2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.component.text || _vm.type) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 mt-4" }, [
                _vm.working
                  ? _c("div", [_vm._m(0)])
                  : _c("div", [
                      _vm.is_prepared
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                href: _vm.watermarked_url,
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm._f("translate")("Download")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              on: { click: _vm.prepare },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("translate")(
                                      "Prepare file for download"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                    ]),
              ]),
            ]),
      ])
    : _vm.type === "mp3"
    ? _c("div", { staticClass: "row text-center py-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("i", { staticClass: "fas fa-volume-up" }),
          _vm._v(" "),
          _c("span", { staticClass: "text-uppercase ms-2" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.component.text || _vm.type) + "\n    "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 mt-4" }, [
          _c(
            "audio",
            {
              ref: "audio",
              staticStyle: { width: "100%" },
              attrs: {
                controls: "",
                controlsList: "nodownload",
                src: _vm.path,
              },
            },
            [
              _vm._v("\n      Your browser does not support the\n      "),
              _c("code", [_vm._v("audio")]),
              _vm._v("\n      element.\n    "),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.component.data.download
          ? _c("div", { staticClass: "col-12 mt-4" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    href: _vm.path,
                    download: _vm.filename,
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm._f("translate")("Download")) +
                      "\n    "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-primary",
        attrs: { type: "button", disabled: "" },
      },
      [
        _c("span", {
          staticClass: "spinner-border spinner-border-sm",
          attrs: { role: "status", "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }